import React, { useEffect, useState } from 'react'
import { Collapse, Modal, Pagination, Drawer, Checkbox } from 'antd';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useLocations } from '../../pages/CityProvinceManagement/connectApi/location';
import { useAgents } from '../../pages/RealEstateConsultants/agentApis';
import Radio from 'antd/es/radio/radio';
import { useAgency } from '../../pages/RealEstateAgency/agencyApis';
import { useManufacturer } from '../../pages/Manufactureres/manufactureresApi';
import ConvertPersianToEnglish from '../ConvertNumberToEnglish';
import { debounce } from 'lodash'
import axios from 'axios';
import { baseURL, baseURLWithoutApi } from "../../baseUrl";

export default function DateNcity(props) {
    const [isRealEStateConsultantExists, setIsRealEStateConsultantExists] = useState(false)
    const [isRealEStateConsultantSuccess, setIsRealEStateConsultantSuccess] = useState(false)
    const { isInManufactureresPage } = props
    const { isInRealEstateAgencyPage } = props
    const { isInRealEStateConsultants } = props
    const { selectedAgent, selectedAgentID } = props
    const { selectedAgency, selectedAgencyID } = props
    const { selectedConstructor, selectedConstructorID } = props
    const { getAllCities, getOneParish, getOneCity, getLocationById } = useLocations((state) => state.actions)
    const { editRealStateAgent, getAllAgents, deleteAgent } = useAgents((state) => state.actions)
    const { addRealStateAgency, editRealStateAgency, getAllAgencies, deleteAgency } = useAgency((state) => state.actions)
    const { addRealStateConstructor, editRealStateConstructor, getAllConstructors, deleteConstructor } = useManufacturer((state) => state.actions)
    const allAgentsPagination = useAgents((state) => state.allAgentsPagination)
    const allAgenciesPagination = useAgency((state) => state.allAgenciesPagination)
    const allManufacturersPagination = useManufacturer((state) => state.allManufacturersPagination)
    const cities = useLocations((state) => state.cities);
    // const parish = useLocations((state) => state.parish);
    const cityByParentId = useLocations((state) => state.cityByParentId);
    const parishByParentId = useLocations((state) => state.parishByParentId);
    const locationName = useLocations((state) => state.locationName);

    const { getLocationByParentId } = useLocations((state) => state.actions)
    const [isCreateAgentModalVisible, setIsCreateAgentModalVisible] = useState(false)
    const [isDeleteAgentModalVisible, setIsDeleteAgentModalVisible] = useState(false)
    const [isDeleteAgencyModalVisible, setIsDeleteAgencyModalVisible] = useState(false)
    const [isDeleteConstructorModalVisible, setIsDeleteConstructorModalVisible] = useState(false)
    const [activeKeys, setActiveKeys] = useState([""]);
    const [selectedCity, setSelectedCity] = useState(null); /* استان */
    const [selectedProvince, setSelectedProvince] = useState(null);  /* شهر */
    const [selectedParish, setSelectedParish] = useState(null); /* منطقه */
    // const [areaList, setAreaList] = useState(parishByParentId)
    const checkRealEstateAgentExists = async (mobile) => { // UPDATE: it can be the name
        try {
            const response = await axios.post(`${baseURL}/RealEstateAgent/DoesRealEstateAgentExists`, {
                mobile: mobile
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error checking agent exists:", error);
            return false;
        }
    };

    const checkRealEstateAgancyExists = async (mobile) => {
        try {
            const response = await axios.post(`${baseURL}/RealEstateAgancy/DoesRealEstateAgancyExists`, {
                mobile: mobile
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error checking agent exists:", error);
            return false;
        }
    };


    const getCurrentPage = () => {
        if (isInRealEStateConsultants) return allAgentsPagination?.currentPage || 1;
        if (isInRealEstateAgencyPage) return allAgenciesPagination?.currentPage || 1;
        if (isInManufactureresPage) return allManufacturersPagination?.currentPage || 1;
        return 1; // Default value
    };

    const getTotalPage = () => {
        if (isInRealEStateConsultants) return allAgentsPagination?.total || 0;
        if (isInRealEstateAgencyPage) return allAgenciesPagination?.total || 0;
        if (isInManufactureresPage) return allManufacturersPagination?.total || 0;
        return 0; // Default value
    };

    const getItemsPerPage = () => {
        if (isInRealEStateConsultants) return allAgentsPagination?.perPage || 100;
        if (isInRealEstateAgencyPage) return allAgenciesPagination?.perPage || 100;
        if (isInManufactureresPage) return allManufacturersPagination?.perPage || 100;
        return 20; // Default value
    };
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [selectedAgentState, setSelectedAgentState] = useState(selectedAgent);
    const [selectedAgencyState, setSelectedAgencystate] = useState(selectedAgency);
    const [selectedConstuctorState, setSelectedConstructorState] = useState(selectedConstructor);

    const [selectedAgentIDState, setSelectedAgentIDState] = useState(selectedAgentID);
    const [selectedAgencyIDState, setSelectedAgencyIDState] = useState(selectedAgencyID);
    const [selectedConstructorIDState, setSelectedConstructorIDState] = useState(selectedConstructorID);

    const [isFilterDrawerVisible, setIsFilterDrawerVisible] = useState(false);
    const [isInsert, setIsInsert] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCityName, setSelectedCityName] = useState('');
    const [selectedProvinceName, setSelectedProvinceName] = useState('');
    const [selectedParishName, setSelectedParisheName] = useState('');
    const [flagForRedBoxes, setFlagForRedBoxes] = useState(false);
    const onCollapseChange = (keys) => {
        setActiveKeys(keys);
    };
    const isCreateAgentModalVisibleHAndler = () => {
        setIsCreateAgentModalVisible(true)
        setSelectedCity(null)
        setSelectedProvince(null)
        setSelectedParish(null)
        setIsInsert(true)
    }
    const removeAgentHandler = async () => {

        await deleteAgent(selectedAgentIDState)
        setIsDeleteAgentModalVisible(false)
        // getAllAgents()
                    getAllAgents(
                0,
                null,
                null,
                null,
                "",
                null,
                selectedProvince,
                selectedCity,
                selectedParish,
                selectedAreaIds,
                page,
                false
            )
    }
    const removeAgencyHandler = async () => {

        await deleteAgency(selectedAgencyIDState)
        getAllAgencies()
        setIsDeleteAgencyModalVisible(false)
    }
    const removeConstructorHandler = async () => {


        await deleteConstructor(selectedConstructorIDState)
        getAllConstructors()
        setIsDeleteConstructorModalVisible(false)
    }
    useEffect(() => {
        getAllCities("2")
    }, [])


    const removeSelectedArea = (id) => {
        const data = JSON.parse(localStorage.getItem("adsFilterState"));
        const updatedAreaIds = selectedAreaIds.filter((areaId) => areaId !== id);
        if (data) {
            // Remove the specific area ID from selectedAreaIds
            data.selectedAreaIds = data.selectedAreaIds.filter((areaId) => areaId !== id);

            // Save the updated data back to localStorage
            localStorage.setItem("adsFilterState", JSON.stringify(data));
        }

        // Update the state to remove the area ID
        // setSelectedAreaIds((prev) => prev.filter((areaId) => areaId !== id));
        setSelectedAreaIds(updatedAreaIds);
    };



    useEffect(() => {
        if (selectedCity) {
            getOneCity(selectedCity)
        }

    }, [selectedCity])
    useEffect(() => {
        if (selectedProvince) {
            getOneParish(selectedProvince)
        }
        // if(parishByParentId){
        //     setAreaList(parishByParentId)
        // }
    }, [selectedProvince])

    useEffect(() => {
        if (selectedAgent) {
            setIsCreateAgentModalVisible(!isCreateAgentModalVisible)
            setSelectedAgentState(selectedAgent)
            console.log("selectedAgent: ");
            console.log(selectedAgent);

            setSelectedCity(selectedAgent.cityId)
            setSelectedCityName(selectedAgent.city?.locName)
            setSelectedParish(selectedAgent.areaId)
            setSelectedParisheName(selectedAgent.area?.locName)
            setSelectedProvince(selectedAgent.stateId)
            setSelectedProvinceName(selectedAgent.state?.locName)
        }
    }, [selectedAgent])
    useEffect(() => {
        if (selectedAgency) {
            // setIsCreateAgencyModalVisible(!isCreateAgencyModalVisible)
            setIsCreateAgentModalVisible(!isCreateAgentModalVisible)
            setSelectedAgencystate(selectedAgency)
            setSelectedCityName(selectedAgency?.state?.locName)
            setSelectedProvinceName(selectedAgency?.city?.locName)
            setSelectedParisheName(selectedAgency?.area?.locName)
        }
    }, [selectedAgency])
    useEffect(() => {
        if (selectedConstructor) {
            // setIsCreateAgencyModalVisible(!isCreateAgencyModalVisible)
            setIsCreateAgentModalVisible(!isCreateAgentModalVisible)
            setSelectedConstructorState(selectedConstructor)
            setSelectedCityName(selectedConstructor?.state)
            setSelectedProvinceName(selectedConstructor?.city)
            setSelectedParisheName(selectedConstructor?.area)
        }
    }, [selectedConstructor])

    useEffect(() => {
        setPage(getCurrentPage());
        setTotalPage(getTotalPage());
        setItemsPerPage(getItemsPerPage());
    }, [allAgentsPagination, allAgenciesPagination, allManufacturersPagination, isInRealEStateConsultants, isInRealEstateAgencyPage, isInManufactureresPage]);

    useEffect(() => {
        if (selectedAgentID) {
            setIsDeleteAgentModalVisible(!isDeleteAgentModalVisible)
            setSelectedAgentIDState(selectedAgentID)
        }

    }, [selectedAgentID])
    useEffect(() => {
        if (selectedAgencyID) {
            setIsDeleteAgencyModalVisible(!isDeleteAgencyModalVisible)
            setSelectedAgencyIDState(selectedAgencyID)
        }

    }, [selectedAgencyID])
    useEffect(() => {
        if (selectedConstructorID) {
            setIsDeleteConstructorModalVisible(!isDeleteConstructorModalVisible)
            setSelectedConstructorIDState(selectedConstructorID)
        }
    }, [selectedConstructorID])
    // useEffect(() => {
    //     if (parishByParentId) {
    //         setAreaList(parishByParentId)
    //         return
    //     }

    // }, [parishByParentId])
    const handleCityChange = (e) => {
        console.log("handleCityChange");

        const city = cities.find((city) => city.id === e.target.value);
        setSelectedCity(e.target.value);
        setSelectedCityName(city ? city.locName : '');
        setActiveKeys([""])
    };
    const handleProvinceChange = (e) => {
        console.log("handleProvinceChange");
        /*  province => shahr */
        setSelectedProvince(e.target.value);
        const province = cityByParentId.find((province) => province.id === e.target.value)
        setSelectedProvinceName(province?.locName)
        setActiveKeys([""])
    };

    const handleDistrictChange = (e) => {
        const selectedId = e.target.value;
        const parish = parishByParentId.find((parish) => parish.id === e.target.value)
        setSelectedParisheName(parish?.locName)
        getLocationById(selectedId)
        setSelectedParish(selectedId);
        setActiveKeys([""])
        // handleSelectDistrict(selectedId); // Pass the selected district ID to the parent handler
    };
    const handlePageChange = (page) => {
        setPage(page)
    }
    const closeDrawerHandler = () => {
        setIsFilterDrawerVisible(false)
    }
    const searchHandler = () => {
        if (isInRealEStateConsultants) {
            getAllAgents(

                /*  
                "id": id,
                "mobile": mobile,
                "firstName": firstName,
                "lastName": lastName,
                "searchQuery": searchQuery,
                "userId": userId,
                "stateId": stateId,
                "cityId": cityId,
                "areaId": areaId,
                "areaArray": areaArray,
                "page": page,
                "isDeleted": isDeleted, */
                0,
                null,
                null,
                null,
                searchQuery,
                null,
                selectedProvince,
                selectedCity,
                selectedParish,
                areas,
                1,
                false
            )
        } else if (isInRealEstateAgencyPage) {
            console.log("isInRealEstateAgencyPage true, call getAllAgencies");

            getAllAgencies(
                // "id": id,
                // "mobile": mobile,
                // "firstName": firstName,
                // "lastName": lastName,
                // "agancyTitle":agancyTitle,
                // "agancyPhone":agancyPhone,
                // "searchQuery": searchQuery,
                // "stateId": stateId,
                // "cityId": cityId,
                // "areaId": areaId,
                // "page": page,
                // "isDeleted": isDeleted,
                0,
                null,
                null,
                null,
                null,
                null,
                searchQuery,
                selectedCity,
                selectedProvince,
                selectedParish,
                1,
                false


            )

        } else if (isInManufactureresPage) {
            getAllConstructors(

                // id, mobile, firstName, lastName, searchQuery,userId, stateId, cityId, areaId, page, isDeleted
                0,
                null,
                null,
                null,
                searchQuery,
                0,
                null,
                null,
                null,
                1,
                false

            )
        }

    }
    const submitFilter = () => {
        if (isInRealEStateConsultants) {
            getAllAgents(

                /*  "id": id,
                 "mobile": mobile,
                 "firstName": firstName,
                 "lastName": lastName,
                 "searchQuery": searchQuery,
                 "userId": userId,
                 "stateId": stateId,
                 "cityId": cityId,
                 "areaId": areaId,
                 "AreasArray": areas
                 "page": page,
                 "isDeleted": isDeleted, 
                 */
                0,
                null,
                null,
                null,
                "",
                null,
                selectedCity,
                selectedProvince,
                selectedParish,
                selectedAreaIds,
                1,
                false
            )
        } else if (isInRealEstateAgencyPage) {
            getAllAgencies(
                0,
                null,
                null,
                null,
                null,
                null,
                "",
                selectedCity,
                selectedProvince,
                selectedParish,
                1,
                false


            )
        } else if (isInManufactureresPage) {
            getAllConstructors(

                // id, mobile, firstName, lastName, searchQuery,userId, stateId, cityId, areaId, page, isDeleted
                0,
                null,
                null,
                null,
                "",
                0,
                selectedCity,
                selectedProvince,
                selectedParish,
                1,
                false

            )
        }

        setIsFilterDrawerVisible(false)
        setFlagForRedBoxes(true)
    }
    useEffect(() => {
        if (isInRealEStateConsultants) {

            /*
            
                            "id": id,
                            "mobile": mobile,
                            "firstName": firstName,
                            "lastName": lastName,
                            "searchQuery": searchQuery,
                            "userId": userId,
                            "stateId": stateId,
                            "cityId": cityId,
                            "areaId": areaId,
                            "areaArray": areaArray,
                            "page": page,
                            "isDeleted": isDeleted,
            */

            getAllAgents(
                0,
                null,
                null,
                null,
                "",
                null,
                selectedProvince,
                selectedCity,
                selectedParish,
                selectedAreaIds,
                page,
                false
            )
        } else if (isInRealEstateAgencyPage) {
            getAllAgencies(
                /* "id": id, */0,
                /* "mobile": mobile, */null,
               /*  "firstName": firstName, */null,
                /* "lastName": lastName, */null,
                /* "agancyTitle":agancyTitle, */null,
                /* "agancyPhone":agancyPhone, */null,
                /* "searchQuery": searchQuery, */"",
                /* "stateId": stateId, */selectedCity,
                /* "cityId": cityId, */selectedProvince,
                /* "areaId": areaId, */selectedParish,
                /* "page": page, */page,
                /* "isDeleted": isDeleted, */false
            )
        }
        else if (isInManufactureresPage) {
            getAllConstructors(

                // id, mobile, firstName, lastName, searchQuery,userId, stateId, cityId, areaId, page, isDeleted
                0,
                null,
                null,
                null,
                "",
                0,
                selectedCity,
                selectedProvince,
                selectedParish,
                page,
                false

            )
        }
    }, [page])


    //پس بقیه هم  استان حذف میشه 
    const cityremoverHandler = () => {
        setSelectedCity(null)
        if (isInRealEStateConsultants) {
            getAllAgents(

                /*  "id": id,
                 "mobile": mobile,
                 "firstName": firstName,
                 "lastName": lastName,
                 "searchQuery": searchQuery,
                 "userId": userId,
                 "stateId": stateId,
                 "cityId": cityId,
                 "areaId": areaId,
                 "areaArray": areaArray,
                 "page": page,
                 "isDeleted": isDeleted, */
                0,
                null,
                null,
                null,
                searchQuery,
                null,
                null,
                null,
                null,
                selectedAreaIds,
                page,
                false
            )
        } else if (isInRealEstateAgencyPage) {
            getAllAgencies(

                // "id": id,
                // "mobile": mobile,
                // "firstName": firstName,
                // "lastName": lastName,
                // "agancyTitle":agancyTitle,
                // "agancyPhone":agancyPhone,
                // "searchQuery": searchQuery,
                // "stateId": stateId,
                // "cityId": cityId,
                // "areaId": areaId,
                // "page": page,
                // "isDeleted": isDeleted,
                0,
                null,
                null,
                null,
                null,
                null,
                "",
                null,
                null,
                null,
                1,
                false
            )
        }
        else if (isInManufactureresPage) {
            getAllConstructors(

                // id, mobile, firstName, lastName, searchQuery,userId, stateId, cityId, areaId, page, isDeleted
                0,
                null,
                null,
                null,
                "",
                0,
                null,
                null,
                null,
                page,
                false

            )
        }
    }

    // حذف شهر
    const provinceRemoverHandler = () => {
        setSelectedProvince(null)
        setSelectedParish(null)
        if (isInRealEStateConsultants) {
            getAllAgents(
                /*  "id": id,
                 "mobile": mobile,
                 "firstName": firstName,
                 "lastName": lastName,
                 "searchQuery": searchQuery,
                 "userId": userId,
                 "stateId": stateId,
                 "cityId": cityId,
                 "areaId": areaId,
                 "areaArray": areaArray,
                 "page": page,
                 "isDeleted": isDeleted, */
                0,
                null,
                null,
                null,
                searchQuery,
                null,
                null,
                null,
                null,
                selectedAreaIds,
                page,
                false
            )
        } else if (isInRealEstateAgencyPage) {
            getAllAgencies(

                // "id": id,
                // "mobile": mobile,
                // "firstName": firstName,
                // "lastName": lastName,
                // "agancyTitle":agancyTitle,
                // "agancyPhone":agancyPhone,
                // "searchQuery": searchQuery,
                // "stateId": stateId,
                // "cityId": cityId,
                // "areaId": areaId,
                // "page": page,
                // "isDeleted": isDeleted,
                0,
                null,
                null,
                null,
                null,
                null,
                "",
                selectedCity,
                null,
                null,
                1,
                false
            )
        }
        else if (isInManufactureresPage) {
            getAllConstructors(

                // id, mobile, firstName, lastName, searchQuery,userId, stateId, cityId, areaId, page, isDeleted
                0,
                null,
                null,
                null,
                "",
                0,
                selectedCity,
                null,
                null,
                page,
                false

            )
        }
    }


    const parishRemoverHandler = () => {
        setSelectedParish(null)
        if (isInRealEStateConsultants) {
            getAllAgents(
                0,
                null,
                null,
                null,
                searchQuery,
                null,
                selectedCity,
                selectedProvince,
                null,
                selectedAreaIds,
                page,
                false
            )
        }
        else if (isInRealEstateAgencyPage) {
            getAllAgencies(
                0,
                null,
                null,
                null,
                null,
                null,
                "",
                selectedCity,
                selectedProvince,
                null,
                1,
                false
            )
        } else if (isInManufactureresPage) {
            getAllConstructors(

                // id, mobile, firstName, lastName, searchQuery,userId, stateId, cityId, areaId, page, isDeleted
                0,
                null,
                null,
                null,
                "",
                0,
                selectedCity,
                selectedProvince,
                null,
                page,
                false

            )
        }


    }
    const allCitiesCollapse = [
        {
            key: '1',
            // label: `استان ${selectedAgency ? `- ${selectedAgency?.state?.locName}` : ''}`,
            label: `استان ${selectedAgency ? `- ${selectedCityName}` : ''}`,
            children: (
                <div>
                    {cities.length > 0 ? (

                        <Radio.Group
                            onChange={handleCityChange}
                            value={selectedCity}

                            className="flex flex-col"
                        >
                            {cities.map((city) => (
                                <Radio key={city.id} value={city.id}>
                                    {city.locName}
                                </Radio>
                            ))}
                        </Radio.Group>
                    ) : (
                        <p className="text-gray-500">هیچ استانی یافت نشد است</p>
                    )}
                </div>
            ),
        },
    ];
    const allProvinsesCollapse = [
        {
            key: '2',
            // label: `شهر ${selectedAgency ? `- ${selectedAgency?.city?.locName} ` : ''}`,
            label: `شهر ${selectedAgency ? `- ${selectedProvinceName} ` : ''}`,
            children: (
                <div>
                    {cityByParentId.length > 0 ? (
                        <Radio.Group
                            onChange={handleProvinceChange}
                            value={selectedProvince}
                            className="flex flex-col"
                        >
                            {cityByParentId.map((city) => (
                                <Radio key={city.id} value={city.id}>
                                    {city.locName}
                                </Radio>
                            ))}
                        </Radio.Group>
                    ) : (
                        <p className="text-gray-500">هیچ شهری یافت نشد است</p>
                    )}
                </div>
            ),
        },
    ];



    const handleSelectDistrict = (checked, id) => {
        if (checked) {
            setSelectedAreaIds((prev) => [...prev, id]);
        } else {
            setSelectedAreaIds((prev) => prev.filter((areaId) => areaId !== id));
        }
    };

    const [selectedAreaIds, setSelectedAreaIds] = useState(() => {
        const storedValue = localStorage.getItem("selectedAreaIds");
        return storedValue ? JSON.parse(storedValue) : [];
    });

    const areas = useLocations((state) => state.areas)
    const [areaList, setAreaList] = useState(areas)
    useEffect(() => {
        if (areas.length) {


            setAreaList(areas)
        } else {
            getLocationByParentId(3)
        }

    }, [areas]);
    const districtsCollapse = [
        {
            key: '3',
            label: 'محله',
            children:
                <div className='flex items-center justify-around w-full gap-4'>
                    <div >
                        <div>لیست محله ها:</div>
                        {/* <div> {selectedAreaIds}</div> */}


                        {/* <div>  {selectedAreaName}</div> */}
                        <div>
                            {selectedAreaIds.length > 0 ? (
                                <p className="mb-1 text-gray-600">
                                    {areaList
                                        .filter((area) => selectedAreaIds.includes(area.id))
                                        .map((area) => area.locName)
                                        .join('، ')}
                                </p>
                            ) : (
                                <p className="text-gray-500">هیچ محله‌ای انتخاب نشده است</p>
                            )}
                        </div>

                        <form>
                            <div className='flex items-center bg-gray-100 p-2 rounded '>
                                <input
                                    autoFocus
                                    onChange={async (e) => {
                                        setAreaList(areas.filter(area => area.locName.includes(e.target.value)))
                                        console.log(e.target.value);
                                        console.log({ areaList });


                                    }}
                                    className='w-full bg-transparent outline-none border-none' type="text"
                                    placeholder="نام محله" />
                                <button type='submit'>
                                    <img src="/icons/search.svg" alt="جست و جو" />
                                </button>
                            </div>
                        </form>
                        <div className="h-[300px] overflow-y-scroll overflow-x-hidden border-r border-l border-b rounded p-2 w-full">
                            {areaList && areaList.map(area => (
                                // <p key={area.id} className="my-2 py-1 border-b hover:bg-gray-100 transition-all w-full">
                                //     <p className="font-bold">{area.locName}</p>

                                // </p>

                                <Checkbox
                                    checked={selectedAreaIds.includes(area.id)}
                                    onChange={(e) => handleSelectDistrict(e.target.checked, area?.id)}
                                    key={area.id}
                                    className="my-2 py-1 border-b hover:bg-gray-100 transition-all w-full">
                                    <p className="font-bold">{area.locName}</p>

                                    {/* {area?.subAreas?.map((item)=><span className='flex'>{item}</span>) } */}
                                    {/* 
                                    <div className="flex gap-2 flex-wrap">
                                        {area?.subAreas?.map((item, index) => (
                                            <span key={index} className="">{item}،</span>
                                        ))}
                                    </div>
                                     */}
                                </Checkbox>
                            ))}
                        </div>

                    </div>
                </div>
            ,
        },
    ]

    // const districtsCollapse = [
    //     {
    //         key: '3',
    //         // label: `محله ${selectedAgency ? `- ${selectedAgency?.area?.locName} ` : ''}`,
    //         label: `محله ${selectedAgency ? `- ${selectedParishName} ` : ''}`,
    //         children: (
    //             <>
    //                      <form>
    //                          <div className='flex items-center bg-gray-100 p-2 rounded '>
    //                              <input
    //                                  autoFocus
    //                                  onChange={async (e) => {
    //                                      setAreaList(parishByParentId.filter(area => area.locName.includes(e.target.value)))

    //                                      console.log(e.target.value);
    //                                      console.log({areaList});


    //                                  }}
    //                                  className='w-full bg-transparent outline-none border-none' type="text"
    //                                  placeholder="نام محله" />
    //                              <button type='submit'>
    //                                  <img src="/icons/search.svg" alt="جست و جو" />
    //                              </button>
    //                          </div>
    //                      </form>
    //                 <div className='max-h-[230px] overflow-scroll'>
    //                     {areaList.length > 0 ? (

    //                         <Radio.Group
    //                             onChange={handleDistrictChange}
    //                             value={selectedParish}
    //                             className="flex flex-col"
    //                         >
    //                             {parishByParentId.map((city) => (
    //                                 <Radio key={city.id} value={city.id}>
    //                                     {city.locName}
    //                                 </Radio>
    //                             ))}
    //                         </Radio.Group>
    //                     ) : (
    //                         <p className="text-gray-500">هیچ محله یافت نشد است</p>
    //                     )}
    //                 </div>
    //             </>
    //         ),
    //     },
    // ];


    // with search undone : 
    // const districtsCollapse = [
    //     {
    //         key: '4',
    //         label: `محله ${selectedAgency ? `- ${selectedParishName} ` : ''}`,
    //         children: (
    //             <div className='flex items-center justify-around w-full gap-4'>
    //                 <div>
    //                     <form>
    //                         <div className='flex items-center bg-gray-100 p-2 rounded'>
    //                             <input
    //                                 onChange={async (e) => {
    //                                     setAreaList(parishByParentId.filter(area => area.locName.includes(e.target.value)));
    //                                 }}
    //                                 className='w-full bg-transparent outline-none border-none'
    //                                 type="text"
    //                                 placeholder="نام محله"
    //                             />
    //                             <button type='submit'>
    //                                 <img src="/icons/search.svg" alt="جست و جو" />
    //                             </button>
    //                         </div>
    //                     </form>
    //                     <div className="h-[300px] overflow-y-scroll overflow-x-hidden border-r border-l border-b rounded p-2 w-full">
    //                         {areaList && areaList.map(area => (
    //                             <Radio.Group
    //                                 onChange={handleDistrictChange}
    //                                 value={selectedParish}
    //                                 className="flex flex-col"
    //                             >
    //                                 {parishByParentId.map((city) => (
    //                                     <Radio key={city.id} value={city.id}>
    //                                         {city.locName}
    //                                     </Radio>
    //                                 ))}
    //                             </Radio.Group>
    //                         ))}
    //                     </div>
    //                 </div>
    //             </div>
    //         ),
    //     },
    // ];
    return (
        <div className='grid grid-cols-8 gap-5 w-full bg-white'>
            <div className='col-span-8 grid grid-cols-8 gap-5' >
                <div className='flex items-center col-span-6 border border-[#747474] h-11 rounded-xl'>

                    <img className='w-[24px] h-[24px]' src='/icons/blueFilter.svg' alt='filter icon' />
                    <p className='text-base font-bold cursor-pointer' onClick={() => setIsFilterDrawerVisible(true)}>فیلترها</p>

                    {/* استان */}
                    {(selectedCity && flagForRedBoxes) && (
                        <div className="flex flex-row flex-wrap  gap-2 my-2 mx-2 ">

                            <div
                                key={selectedCity}
                                className="rounded border border-red-500 px-2 py-1 text-red-600 flex items-center  my-2"
                            >
                                <span >{selectedCityName}</span>
                                <img
                                    src="/icons/close.svg"
                                    alt="حذف"
                                    className=" cursor-pointer w-5"
                                    onClick={() => {
                                        cityremoverHandler()
                                    }

                                    }
                                />
                            </div>

                        </div>
                    )}
                    {(selectedProvince && flagForRedBoxes) && (
                        <div className="flex flex-row flex-wrap  gap-2 my-2 mx-2">

                            <div
                                key={selectedProvince}
                                className="rounded border border-red-500 px-2 py-1 text-red-600 flex items-center"
                            >
                                <span>{selectedProvinceName}</span>
                                <img
                                    src="/icons/close.svg"
                                    alt="حذف"
                                    className=" cursor-pointer "
                                    onClick={() => {
                                        provinceRemoverHandler()
                                    }

                                    }
                                />
                            </div>

                        </div>
                    )}
                    {(selectedParish && flagForRedBoxes) && (
                        <div className="flex flex-row flex-wrap  gap-2 my-2 mx-2 ">

                            <div
                                key={selectedParish}
                                className="rounded border border-red-500 px-2 py-1 text-red-600 flex items-center"
                            >
                                <span>{locationName}</span>
                                <img
                                    src="/icons/close.svg"
                                    alt="حذف"
                                    className=" cursor-pointer "
                                    onClick={() => {
                                        parishRemoverHandler()
                                    }

                                    }
                                />
                            </div>

                        </div>
                    )}

                </div>
                <div
                    className='cursor-pointer col-span-2 bg-[#227934] h-11 flex items-center justify-center rounded-xl'
                    onClick={() => isCreateAgentModalVisibleHAndler()}
                >
                    <p className='text-white text-center'>ثبت کاربر</p>
                </div>
            </div>
            <div className='flex items-center justify-between h-11 col-span-8 w-full border border-[#747474] rounded-xl'>
                <input
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {

                            searchHandler()
                        }
                    }}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className='w-full h-full outline-none border-none rounded-xl p-4 ' placeholder='جست و جو (حداقل ۳ کاراکتر)' />
                <img
                    src="/icons/search-filter.svg"
                    alt='search icon'
                    className='ml-2 cursor-pointer'
                    onClick={searchHandler} />
            </div>


            <Modal
                title=" اطلاعات کاربر"
                open={isCreateAgentModalVisible}
                onOk={() => setIsCreateAgentModalVisible(false)}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
                closeIcon={true}
                maskClosable={true}
                onCancel={() => {
                    setIsCreateAgentModalVisible(false)
                    setSelectedAgentState(null)
                    setSelectedAgencystate(null)
                    setIsInsert(false)
                    setSelectedParisheName("")
                    setSelectedCityName("")
                    setSelectedProvinceName("")
                }}>
                {isRealEStateConsultantExists && (
                    <p className='bg-red-700 p-2 rounded text-white text-center'>شماره تکراری</p>
                )}
                {isRealEStateConsultantSuccess && (
                    <p className='bg-green-500 p-2 rounded text-white text-center'>ثبت با موفقیت انجام شد</p>
                )}
                <Formik
                    initialValues={{
                        firstName: selectedAgentState?.firstName || selectedAgencyState?.firstName || selectedConstuctorState?.firstName || "", // Use selectedAgent.name for editing, default to an empty string
                        lastName: selectedAgentState?.lastName || selectedAgencyState?.lastName || selectedConstuctorState?.lastName || "",
                        phoneNumber: selectedAgentState?.mobile || selectedAgencyState?.mobile || selectedConstuctorState?.mobile || "",
                        agencyName: selectedAgencyState?.agancyTitle || "",
                        agencyPhone: selectedAgencyState?.agancyPhone || "",
                        stateId: selectedAgentState?.stateId || selectedAgencyState?.stateId || selectedConstuctorState?.stateId || "",
                        cityId: selectedAgentState?.cityId || selectedAgencyState?.cityId || selectedConstuctorState?.cityId || "",
                        areaId: selectedAgentState?.areaId || selectedAgencyState?.areaId || selectedConstuctorState?.areaId || "",
                        guildCode: selectedAgencyState?.guildCode || "",
                        secretaryName: selectedAgencyState?.secretaryName || "",
                        secretaryMobile: selectedAgencyState?.secretaryMobile || "",

                    }}
                    enableReinitialize
                    validate={values => {
                        const errors = {};
                        // if (!values.firstName) {
                        //     errors.firstName = '   نام را وارد کنید ';
                        // } else
                        //     if (!values.lastName) {
                        //         errors.lastName = '   نام خانوادگی را وارد کنید  ';
                        //     } else
                        if (!values.phoneNumber) {
                            errors.phoneNumber = '    شماره تماس را وارد کنید ';
                            setIsRealEStateConsultantExists(false)
                            setIsRealEStateConsultantSuccess(false)
                        }

                        return errors;
                    }}

                    onSubmit={async (values, { resetForm }) => {
                        setIsCreateAgentModalVisible(false)
                        setIsRealEStateConsultantExists(false)
                        setIsRealEStateConsultantSuccess(false)
                        console.log("Form Submit");

                        if (isInRealEstateAgencyPage) {
                            if (isInsert) {
                                try {
                                    // addRealStateAgency: async (firstName, lastName, mobile, agancyTitle, agancyPhone, stateId, cityId, areaId, guildCode, secretaryName, secretaryMobile, address)

                                    // firstName,
                                    // lastName,
                                    // mobile,
                                    // agancyTitle,
                                    // agancyPhone,
                                    // stateId,
                                    // cityId,
                                    // areaId,
                                    // guildCode,
                                    // secretaryName,
                                    // secretaryMobile,
                                    // address

                                    console.log(values);


                                    const response = await addRealStateAgency(
                                        values.firstName,
                                        values.lastName,
                                        values.mobile,
                                        values.agencyTitle,
                                        values.phoneNumber,
                                        selectedProvince,
                                        selectedCity,
                                        selectedParish,
                                        values.guildCode,
                                        values.secretaryName,
                                        values.secretaryMobile,
                                        values.address
                                    );

                                    if (response) {
                                        console.log(response);

                                        resetForm(); // Clear the form values
                                        setSelectedCity(null);
                                        setSelectedProvince(null);
                                        setSelectedParish(null);
                                        setIsCreateAgentModalVisible(false); // Close the modal
                                        getAllAgencies(
                                            0,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            searchQuery,
                                            null,
                                            null,
                                            null,
                                            1,
                                            false


                                        )

                                    } else {
                                        console.error("API call failed", response);
                                    }
                                } catch (error) {
                                    console.error("Error during API call", error);
                                }
                            } else { /* ویرایشه */
                                const response = await editRealStateAgency(
                                    selectedAgencyState?.id,
                                    values.firstName,
                                    values.lastName,
                                    values.phoneNumber,
                                    values.agencyTitle,
                                    values.agencyPhone,
                                    selectedCity,
                                    selectedProvince,
                                    selectedParish
                                )
                                if (response) {
                                    getAllAgencies(
                                        0,
                                        null,
                                        null,
                                        null,
                                        null,
                                        null,
                                        searchQuery,
                                        null,
                                        null,
                                        null,
                                        1,
                                        false


                                    )
                                    resetForm(); // Clear the form values
                                    setSelectedCity(null);
                                    setSelectedProvince(null);
                                    setSelectedParish(null);
                                }

                            }

                        } else if (isInRealEStateConsultants) {
                            try {
                                console.log("Starting API call...");
                                console.log("Parameters:", {
                                    id: selectedAgentState?.id || 0,
                                    phoneNumber: values.phoneNumber,
                                    firstName: values.firstName,
                                    lastName: values.lastName,
                                    selectedCity,
                                    selectedProvince,
                                    selectedParish
                                });
                                // editRealStateAgent: async (id, mobile, firstName, lastName, searchQuery, userId, stateId, cityId, areaId, page)
                                const response = await editRealStateAgent(
                                    selectedAgentState?.id || 0,
                                    values.phoneNumber,
                                    values.firstName,
                                    values.lastName,
                                    "",
                                    null,
                                    selectedProvince,
                                    selectedCity,
                                    selectedParish
                                );

                                console.log("Response type:", typeof response);
                                console.log("Response value:", response);


                                if (response && response.id > 0) {
                                    console.log("isInRealEStateConsultants", response);

                                    console.log("Try to get the agents list, page: ", page);

                                    // get the list again
                                    // getAllAgents: async (id, mobile, firstName, lastName, searchQuery, userId, stateId, cityId, areaId, areaArray, page, isDeleted)
                                    getAllAgents(
                                        0,
                                        null,
                                        null,
                                        null,
                                        searchQuery,
                                        null,
                                        selectedProvince,
                                        selectedCity,
                                        null,
                                        [],
                                        page,
                                        false);

                                    resetForm(); // Clear the form values
                                    setSelectedCity(null);
                                    setSelectedProvince(null);
                                    setSelectedParish(null);
                                    setIsCreateAgentModalVisible(true); // Close the modal
                                    setIsRealEStateConsultantSuccess(true)

                                } else if (response && response.id < 0) {
                                    console.error("API call failed", response);
                                    setIsCreateAgentModalVisible(true); // Close the modal
                                    setIsRealEStateConsultantExists(true)
                                    setIsRealEStateConsultantSuccess(false)
                                } else {
                                    // این حالت برای وقتیه که id صفر یا undefined باشه
                                    console.error("API call failed - پاسخ نامعتبر:", response);
                                    // alert("خطا: پاسخ سرور نامعتبر است یا Id صفر است");
                                    setIsRealEStateConsultantSuccess(false)
                                }

                            } catch (error) {
                                // لاگ کردن خطای دقیق
                                setIsRealEStateConsultantSuccess(false)
                                console.error("خطا در فراخوانی API:", error);
                                if (error.response) {
                                    if (error.response.data?.id == -1) {
                                        setIsCreateAgentModalVisible(true); // Keep the modal open
                                        setIsRealEStateConsultantExists(true)
                                        setIsRealEStateConsultantSuccess(false)
                                    }
                                    console.log("کد وضعیت:", error.response.status); // مثلاً 200 یا خطاهای دیگر
                                    console.log("دیتای خطا:", error.response.data); // شیء TblBseRealEstateAgent
                                    console.error("پیام خطا:", error.response.data?.message || "خطای ناشناخته");
                                    // alert(error.response.data?.message || "خطا در درخواست به سرور");
                                } else {
                                    console.error("خطا بدون پاسخ سرور:", error.message);
                                    // alert("خطایی در اتصال به سرور رخ داد");
                                }
                            }
                        } else if (isInManufactureresPage) {
                            if (isInsert) {
                                try {
                                    const response = await addRealStateConstructor(
                                        values.phoneNumber,
                                        values.firstName,
                                        values.lastName,
                                        selectedCity,
                                        selectedProvince,
                                        selectedParish
                                    );

                                    if (response) {

                                        resetForm(); // Clear the form values
                                        setSelectedCity(null);
                                        setSelectedProvince(null);
                                        setSelectedParish(null);
                                        setIsCreateAgentModalVisible(false); // Close the modal
                                        getAllConstructors(

                                            // id, mobile, firstName, lastName, searchQuery,userId, stateId, cityId, areaId, page, isDeleted
                                            0,
                                            null,
                                            null,
                                            null,
                                            "",
                                            0,
                                            null,
                                            null,
                                            null,
                                            page,
                                            false

                                        )

                                    } else {
                                        console.error("API call failed", response);
                                    }
                                } catch (error) {
                                    console.error("Error during API call", error);
                                }
                            } else {

                                const response = await editRealStateConstructor(

                                    // "id": 0,
                                    // "mobile": "string",
                                    // "firstName": "string",
                                    // "lastName": "string",
                                    // "stateId": 0,
                                    // "cityId": 0,
                                    // "areaId": 0
                                    selectedConstructor?.id,
                                    values.phoneNumber,
                                    values.firstName,
                                    values.lastName,
                                    selectedCity,
                                    selectedProvince,
                                    selectedParish

                                )
                                if (response) {
                                    getAllConstructors(
                                        0,
                                        null,
                                        null,
                                        null,
                                        searchQuery,
                                        0,
                                        null,
                                        null,
                                        null,
                                        1,
                                        false


                                    )
                                    resetForm(); // Clear the form values
                                    setSelectedCity(null);
                                    setSelectedProvince(null);
                                    setSelectedParish(null);
                                }
                            }
                        }

                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue
                    }) => (
                        <>
                            {selectedAgentState?.divarToken && (
                                <div>
                                    <a href={`https://divar.ir/v/${selectedAgentState?.divarToken}`} target='_blank'>لینک دیوار</a>
                                </div>
                            )

                            }
                            <Form onSubmit={handleSubmit} className=' gap-4 mt-8'>
                                <div className='grid grid-cols-3 gap-4 mb-5'>
                                    {!isInRealEstateAgencyPage && (
                                        <>
                                            <div className='flex flex-col gap-1 items-start '>
                                                <label htmlFor="firstName" className='font-bold'>نام و نام خانوادگی </label>
                                                <Field type="text" name="firstName" id="firstName" className='w-full border-2  bg-[#F4F4F4] rounded-lg  px-2 py-1 outline-none '
                                                />
                                                <ErrorMessage name="firstName">{msg => <div className='text-[11px]   pr-2'>{msg}</div>}</ErrorMessage>
                                            </div>
                                            <div className='flex flex-col gap-1 items-start'>
                                                <label htmlFor="lastName" className='font-bold'>نام آژانس   </label>
                                                <Field type="text" name="lastName" id="lastName" className='w-full border-2  px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                                                <ErrorMessage name="lastName">{msg => <div className='text-[11px] pr-2'>{msg}</div>}</ErrorMessage>
                                            </div>
                                            <div className='flex flex-col gap-1 items-start'>
                                                <label htmlFor="phoneNumber" className='font-bold'>    شماره تماس </label>
                                                <Field type="text" name="phoneNumber" id="phoneNumber" className='w-full border-2    px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' onChange={async (e) => {
                                                    const convertedValue = ConvertPersianToEnglish(e.target.value);
                                                    setFieldValue("phoneNumber", convertedValue)

                                                    const phoneNumber = e.target.value.trim();
                                                    if (phoneNumber && phoneNumber.length >= 10) { // حداقل طول شماره موبایل
                                                        console.log("Checking if agent exists for:", phoneNumber);

                                                        let exists = false;

                                                        if (isInRealEstateAgencyPage) {
                                                            exists = await checkRealEstateAgancyExists(phoneNumber);
                                                        } else {
                                                            exists = await checkRealEstateAgentExists(phoneNumber);
                                                        }


                                                        if (exists) {
                                                            console.log("Agent already exists!");
                                                            setIsRealEStateConsultantExists(true);
                                                            // setFieldError('phoneNumber', 'این شماره موبایل قبلاً ثبت شده است');
                                                        } else {
                                                            console.log("Agent does not exist - OK to proceed");
                                                            setIsRealEStateConsultantExists(false);
                                                        }
                                                    }
                                                }} />
                                                {/* <ErrorMessage name="phoneNumber">{msg => <div className='text-[11px]  pr-2'>{msg}</div>}</ErrorMessage> */}
                                            </div>
                                        </>
                                    )}
                                    {
                                        isInRealEstateAgencyPage && (
                                            <>
                                                <div className='flex flex-col gap-1 items-start'>
                                                    <label htmlFor="agencyTitle" className='font-bold'> نام آژانس  <span className='text-red-700'>*</span></label>
                                                    <Field type="text" name="agencyTitle" id="agencyTitle" className='w-full border-2  px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                                                    <ErrorMessage name="agencyTitle">{msg => <div className='text-[11px] pr-2'>{msg}</div>}</ErrorMessage>
                                                </div>
                                                <div className='flex flex-col gap-1 items-start'>
                                                    <label htmlFor="phoneNumber" className='font-bold'> شماره آژانس <span className='text-red-700'>*</span></label>
                                                    <Field type="text" name="phoneNumber" id="phoneNumber" className='w-full border-2    px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                                                    <ErrorMessage name="phoneNumber">{msg => <div className='text-[11px]  pr-2'>{msg}</div>}</ErrorMessage>
                                                </div>
                                                <div className='flex flex-col gap-1 items-start'>
                                                    <label htmlFor="guildCode" className='font-bold'> شناسه صنفی </label>
                                                    <Field type="text" name="guildCode" id="guildCode" className='w-full border-2    px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                                                </div>
                                                <div className='col-span-3'>
                                                    <label htmlFor="address" className='font-bold'>    آدرس آژانس </label>
                                                    <Field type="text" name="address" id="address" className='w-full border-2    px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                                                </div>
                                                <div className='col-span-3 bg-blue-200 p-2'>
                                                    اطلاعات مدیریت
                                                </div>

                                                <div className='flex flex-col gap-1 items-start '>
                                                    <label htmlFor="firstName" className='font-bold'>نام  </label>
                                                    <Field type="text" name="firstName" id="firstName" className='w-full border-2  bg-[#F4F4F4] rounded-lg  px-2 py-1 outline-none '
                                                    />
                                                </div>

                                                <div className='flex flex-col gap-1 items-start'>
                                                    <label htmlFor="lastName" className='font-bold'> نام و نام خانوادگی   </label>
                                                    <Field type="text" name="lastName" id="lastName" className='w-full border-2  px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                                                </div>
                                                <div className='flex flex-col gap-1 items-start'>
                                                    <label htmlFor="mobile" className='font-bold'> موبایل   </label>
                                                    <Field type="text" name="mobile" id="mobile" className='w-full border-2  px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                                                </div>
                                                <div className='col-span-3 bg-green-200 p-2'>
                                                    اطلاعات منشی
                                                </div>
                                                <div className='flex flex-col gap-1 items-start'>
                                                    <label htmlFor="secretaryName" className='font-bold'>نام و نام خانوادگی   </label>
                                                    <Field type="text" name="secretaryName" id="secretaryName" className='w-full border-2  px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                                                </div>
                                                <div className='flex flex-col gap-1 items-start'>
                                                    <label htmlFor="secretaryMobile" className='font-bold'> موبایل   </label>
                                                    <Field type="text" name="secretaryMobile" id="secretaryMobile" className='w-full border-2  px-2 py-1 outline-none bg-[#F4F4F4] rounded-lg' />
                                                </div>
                                            </>
                                        )
                                    }
                                </div>


                                <div className='grid grid-cols-3 gap-4'>
                                    <Collapse accordion
                                        items={allCitiesCollapse}
                                        activeKey={activeKeys}
                                        onChange={onCollapseChange}
                                    />
                                    <Collapse accordion
                                        items={allProvinsesCollapse}
                                        activeKey={activeKeys} onChange={onCollapseChange} />
                                    <Collapse accordion
                                        items={districtsCollapse}
                                        activeKey={activeKeys} onChange={onCollapseChange}
                                    // onClick={()=>setAreaList(parishByParentId)}
                                    />

                                </div>
                                <div className='bg-[#227934] text-white flex items-center justify-center  w-full mx-auto max-w-[118px] mt-5 rounded-xl'>
                                    <button className='  py-2  font-bold ' onClick={handleSubmit} type='submit'
                                    // className={`bg-green-600 text-white rounded px-6 py-1 my-4 ${loader ? "pointer-events-none opacity-60" : "pointer-events-auto opacity-100"} `}
                                    >
                                        ثبت
                                    </button>
                                </div>
                            </Form>
                        </>
                    )}
                </Formik>
            </Modal>

            <Modal title="آیا از حذف مشاور اطمینان دارید؟"
                open={isDeleteAgentModalVisible} footer={false} onCancel={() => {
                    // setShownBlog(null)
                    // setIsShowRemoveBlogHint(false)
                    setIsDeleteAgentModalVisible(false)
                }}>
                <div className="w-full grid grid-cols-1 gap-4 mt-6">
                    <button
                        // onClick={() => removeBlogHandler()}
                        onClick={() => removeAgentHandler()}
                        className="px-6 py-1 bg-red-600 text-white rounded">
                        حذف
                    </button>
                </div>
            </Modal>
            <Modal title="آیا از حذف آژانس اطمینان دارید؟"
                open={isDeleteAgencyModalVisible} footer={false} onCancel={() => {
                    // setShownBlog(null)
                    // setIsShowRemoveBlogHint(false)
                    setIsDeleteAgencyModalVisible(false)
                }}>
                <div className="w-full grid grid-cols-1 gap-4 mt-6">
                    <button
                        // onClick={() => removeBlogHandler()}
                        onClick={() => removeAgencyHandler()}
                        className="px-6 py-1 bg-red-600 text-white rounded">
                        حذف
                    </button>
                </div>
            </Modal>
            <Modal title="آیا از حذف سازنده اطمینان دارید؟"
                open={isDeleteConstructorModalVisible} footer={false} onCancel={() => {
                    setIsDeleteConstructorModalVisible(false)
                }}>
                <div className="w-full grid grid-cols-1 gap-4 mt-6">
                    <button
                        // onClick={() => removeBlogHandler()}
                        onClick={() => removeConstructorHandler()}
                        className="px-6 py-1 bg-red-600 text-white rounded">
                        حذف
                    </button>
                </div>
            </Modal>

            {/* <Drawer title="فیلتر ها " onClose={closeDrawerHandler} open={isFilterDrawerVisible}>

            </Drawer> */}
            <Drawer
                title={
                    <div className='flex justify-between items-center w-full' >
                        <span>فیلتر ها</span>
                        <button
                            className='text-[#D70000] shadow-md rounded-md text-[12px] font-normal py-2 px-4 cursor-pointer'
                            onClick={() => {
                                setSelectedCity(null)
                                setSelectedProvince(null)
                                setSelectedParish(null)
                                setIsFilterDrawerVisible(false)
                            }}
                        >
                            پاکسازی فیلترها
                        </button>
                    </div>
                }
                onClose={closeDrawerHandler}
                open={isFilterDrawerVisible}
            >
                {/* Drawer content */}
                <Collapse accordion
                    className='my-1'
                    items={allCitiesCollapse}
                    activeKey={activeKeys} onChange={onCollapseChange} />


                <Collapse accordion
                    className='my-1'
                    items={allProvinsesCollapse}
                    activeKey={activeKeys} onChange={onCollapseChange} />

                <Collapse accordion
                    className='my-1'
                    items={districtsCollapse}
                    activeKey={activeKeys} onChange={onCollapseChange} />

                <div>
                    {selectedAreaIds?.length > 0 && (
                        <div className="flex flex-row flex-wrap  gap-2 my-2 ">
                            {areaList
                                .filter((area) => selectedAreaIds.includes(area.id))
                                .map((area) => (
                                    <div
                                        key={area.id}
                                        className="rounded border border-red-500 px-2 py-1 text-red-600 flex items-center"
                                    >
                                        <span>{area.locName}</span>
                                        <img
                                            src="/icons/close.svg"
                                            alt="حذف"
                                            className=" cursor-pointer "
                                            onClick={() => {
                                                removeSelectedArea(area.id)
                                                handleSelectDistrict(false, area.id)
                                            }

                                            }
                                        />
                                    </div>
                                ))}
                        </div>
                    )}
                </div>

                {/* copy from AdsFilter     */}
                {/* <Collapse accordion items={districtsCollapse} activeKey={activeKeys} onChange={onCollapseChange} /> */}

                <div className='bg-[#227934] text-white flex items-center justify-center  w-full mx-auto max-w-[118px] mt-5 rounded-xl font-light '>
                    <button className='  py-2  font-bold '
                        onClick={submitFilter}
                    // className={`bg-green-600 text-white rounded px-6 py-1 my-4 ${loader ? "pointer-events-none opacity-60" : "pointer-events-auto opacity-100"} `}
                    >
                        اعمال فیلتر
                    </button>
                </div>
            </Drawer>
            <div className='fixed w-full z-10 bottom-0 bg-white py-1  flex justify-center pl-[23%] mt-7'>


                <Pagination
                    current={page}
                    total={totalPage}
                    pageSize={itemsPerPage}
                    onChange={handlePageChange}
                    showSizeChanger={false}               
                    showQuickJumper     
                />
            </div>

        </div>
    )
}
